import React from 'react';
import { Link } from 'react-router-dom';

const FacebookIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
  </svg>
);

const XIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const socialLinks = [
  { name: 'Facebook', href: 'https://www.facebook.com/TubeTactix', icon: FacebookIcon },
  { name: 'X', href: 'https://x.com/tubetactixcom', icon: XIcon },
];

const Footer = () => {
  return (
    <footer className="w-full mt-auto py-6 px-4 sm:px-6 lg:px-8 bg-transparent text-gray-400">
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex justify-center space-x-6 md:order-2">
          {socialLinks.map((item) => (
            <a key={item.name} href={item.href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-300">
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>
        <div className="mt-8 md:mt-0 md:order-1 flex flex-col items-center md:flex-row gap-y-4 md:gap-x-8">
          <p className="text-xs leading-5">
            &copy; {new Date().getFullYear()} TubeTactix. All rights reserved.
          </p>
          <div className="flex items-center gap-x-6">
            <Link to="/privacy" className="text-xs leading-5 text-gray-400 hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs leading-5 text-gray-400 hover:text-white">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;